import React from 'react';
import { getNestedValue, TreeListCellProps } from '@progress/kendo-react-treelist';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { classNames, Keys } from '@progress/kendo-react-common';
import capitalizeFirstLetter from '../../../../../common/utility/capitalizeFirstLetter';
import DocumentNameCell from '../documentNameCell/documentNameCell';

const TreeListCell = (props: TreeListCellProps) => {
  //@ts-ignore
  const { level = [0], expanded, dataItem, format, id, ariaColumnIndex } = props;
  const data = getNestedValue('name', dataItem);
  const intl = useInternationalization();
  const navigationAttributes = useTableKeyboardNavigation(id);
  let dataAsString = '';
  const prefix = dataItem.type && <span className="treelist-prefix">{capitalizeFirstLetter(dataItem.type + ' ')}</span>;

  const onKeyDownHandler = React.useCallback(
    (event) => {
      if (event.isDefaultPrevented()) {
        return;
      }

      if (event.keyCode === Keys.enter && props.expandable) {
        event.preventDefault();
        props.onExpandChange(event, dataItem, level);
      }
    },
    [props.expandable, dataItem, level]
  );

  if (data !== undefined && data !== null) {
    dataAsString = format ? intl.format(format, data) : data.toString();
  }

  const icons: Array<any> = [];
  if (props.expandable) {
    icons.push(...level.slice(1).map((_x, i) => <span className="k-icon k-i-none" key={i} />));

    if (dataItem.documentId === undefined) {
      icons.push(
        <span
          className={`k-icon k-i-${expanded ? 'collapse' : 'expand'}`}
          key="expand-collapse"
          onClick={(event) => props.onExpandChange(event, dataItem, level)}
        />
      );
    } else {
      icons.push(<span className="k-icon k-i-none" key={icons.length} />);
    }
  }

  const defaultRendering = (
    <td
      style={{ width: 350 }}
      className={classNames(props.className, {
        ['k-text-nowrap']: props.expandable,
      })}
      colSpan={props.colSpan}
      aria-colindex={ariaColumnIndex}
      role={'gridcell'}
      onKeyDown={onKeyDownHandler}
      {...navigationAttributes}>
      {icons}
      {prefix}
      <span className={`${dataItem.documentId === undefined ? 'treelist-header-text' : ''}`}>{dataAsString}</span>
    </td>
  );

  return dataItem.documentId !== undefined ? (
    <DocumentNameCell {...props} width={350} icon={icons} origin="documentsPage" />
  ) : props.render ? (
    props.render.call(undefined, defaultRendering, props)
  ) : (
    defaultRendering
  );
};

TreeListCell.displayName = 'KendoReactTreeListCell';

export default TreeListCell;
